import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import List from '../selfAssessments/List';
import { loadSelfAssessments } from '../selfAssessments/actions';

class ChildSelfAssessmentList extends Component {
	constructor(props) {
		super(props);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		this.loadListData(this.props.childId, { pageNumber: 1, pageSize: this.props.pagination.pageSize });
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.childId !== this.props.childId) {
			this.loadListData(nextProps.childId, { ...nextProps.pagination });
		}
	}

	loadListData(childId, { sortKey = 'date', sortDirection = 'desc', pageNumber, pageSize }) {
		if (childId) {
			this.props.loadByChild({ childId, sortKey, sortDirection, pageSize, pageNumber });
		}
	}

	handleListEvent(listPagination) {
		this.loadListData(this.props.childId, { ...listPagination });
	}

	render() {
		const { isReadonly, data, pagination, childId, t, ...rest } = this.props;

		return <div>
			<List onFetchData={this.handleListEvent} data={data} childId={childId} {...pagination} {...rest} />
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const childId = ownProps.childId;
	const {
		pagination,
		entities: { selfAssessments }
	} = state;

	const selfAssessmentsPagination = pagination.selfAssessments[`child-${childId}`] || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: selfAssessmentsPagination.ids.map(id => selfAssessments[id]),
		pagination: selfAssessmentsPagination,	
		childId
	};
};
ChildSelfAssessmentList.propTypes = {
	childId: PropTypes.number.isRequired
};

export default connect(mapStateToProps, {
	loadByChild: loadSelfAssessments
})(withTranslation()(ChildSelfAssessmentList));